import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app works!';
}



// WEBPACK FOOTER //
// D:/jordan/stunii-cms-stunii-cms-Appzorro1/stunii-cms-stunii-cms-Appzorro1/src/app/app.component.ts